import { useNavigate } from 'react-router-dom';
import { Badge, Button } from '../../../components/ui';
import { Cell, ListPage } from '../../../components/common/ListPage/ListPage';

export default function TemplateList() {
  const navigate = useNavigate();
  const add = <Button leftIcon="plus" onClick={() => navigate('/templates/new')}>New template</Button>;
  return (
    <ListPage
      title="Quote templates"
      subtitle="Ready-made labour and material lists, e.g. “2BHK new wiring”. Load them into a quotation in one click."
      path="/templates"
      searchPlaceholder="Search template"
      actions={add}
      rowTo={(t) => `/templates/${t._id}/edit`}
      rowActions={(t) => [{ label: 'Edit', icon: 'edit', onClick: () => navigate(`/templates/${t._id}/edit`) }]}
      columns={[
        { header: 'Template', sort: 'name', render: (t) => <Cell title={t.name} sub={t.description} />, csv: (t) => t.name },
        { header: 'Labour lines', align: 'right', render: (t) => t.labourItems?.length ?? 0 },
        { header: 'Material lines', align: 'right', render: (t) => t.materialItems?.length ?? 0 },
        { header: 'Status', sort: 'isActive', render: (t) => (t.isActive !== false ? <Badge tone="green" dot>Active</Badge> : <Badge tone="grey" dot>Hidden</Badge>) },
      ]}
      mobile={(t) => ({ title: t.name, subtitle: `${t.labourItems?.length ?? 0} labour · ${t.materialItems?.length ?? 0} material` })}
      empty={{ icon: 'quote', title: 'No templates yet', message: 'Save the lists you quote often, like a 1BHK or 2BHK wiring job.', action: add }}
    />
  );
}
